/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedBlurbShipping_item = {|
  +lastTransaction?: ?{|
    +shipmentQuotes: ?$ReadOnlyArray<?{|
      +isCustom: ?boolean;
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbShipping_item",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "Transaction",
          "name": "lastTransaction",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ShipmentQuote",
              "name": "shipmentQuotes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "isCustom",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedBlurbShippingCustomQuote_transaction",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item"
};

module.exports = fragment;
